import { InjectionToken } from '@angular/core';

export let AUTHENTICATION = new InjectionToken<{ isAuthentication: boolean }>('AUTHENTICATION_VESTA');